module.exports = __webpack_public_path__ + "static/media/sleep-basics-large@2x.46f53dd2.png";